var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "overlay-modal",
    {
      ref: "overlayModal",
      staticClass: "without-header",
      staticStyle: { "z-index": "1040" }
    },
    [
      [
        _c("div", { staticClass: "modal-map" }, [
          _c("div", { class: _vm.classes }, [
            _c("div", [
              _c("div", { staticClass: "mb-5" }, [
                _c("p", { staticClass: "mb-1 text-uppercase" }, [
                  _c("b", [_vm._v(_vm._s(_vm.hotels.length))]),
                  _vm._v(
                    " hotel " +
                      _vm._s(_vm.hotels.length === 1 ? "trovato" : "trovati") +
                      "\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("CustomOrderSelect", {
                      staticClass: "lg",
                      attrs: { list: _vm.order },
                      on: { change: _vm.onChangeOrder }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-3 d-flex justify-content-between" },
                [
                  _c("div", { staticClass: "d-flex" }, [
                    _c("p", { staticClass: "mb-0" }, [
                      _c("b", [_vm._v("Filtra risultati")]),
                      _c("span", [_vm._v(" | " + _vm._s(_vm.counter))])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-secondary",
                        attrs: { disabled: _vm.isDisabledReset },
                        on: { click: _vm.onResetFilter }
                      },
                      [_vm._v("reset")]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("DropdownFilterHotel", {
                    attrs: {
                      "is-dropdown": false,
                      list: _vm.hotels,
                      value: _vm.getFilter
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "tasks pb-5",
                  style: "height: " + (_vm.windowHeight - 55) + "px;"
                },
                _vm._l(_vm.hotelsFiltered, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      on: {
                        mouseover: function($event) {
                          return _vm.onMouseHover(item)
                        }
                      }
                    },
                    [
                      _c("HotelPanel", {
                        staticClass: "mb-3",
                        attrs: {
                          minimize: _vm.expanded,
                          value: item,
                          selected: _vm.isSelectedHotel(item)
                        },
                        on: {
                          select: _vm.onSelectHotel,
                          detail: _vm.onShowDetail
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    on: { click: _vm.onChangeExpand }
                  },
                  [_vm._v("espandi mappa")]
                ),
                _vm._v(" "),
                _c(
                  "GmapMap",
                  {
                    ref: "mapRef",
                    staticClass: "map",
                    attrs: {
                      options: {
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: true,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: false,
                        disableDefaultUi: false
                      },
                      center: _vm.center,
                      zoom: _vm.zoom,
                      "map-type-id": "terrain"
                    }
                  },
                  _vm._l(_vm.markers, function(m, index) {
                    return _c(
                      "gmap-custom-marker",
                      {
                        key: index,
                        attrs: {
                          offsetY: -10,
                          "z-index": m.zIndex,
                          marker: m,
                          alignment: "top"
                        },
                        nativeOn: {
                          click: function($event) {
                            return _vm.onSelectMarker(m)
                          }
                        }
                      },
                      [
                        _c("CustomHotelMarker", {
                          attrs: { value: m, hover: _vm.selectedItem }
                        })
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm.showItem
              ? _c("ModalHotelDetail", {
                  ref: "modalHotelDetail",
                  attrs: {
                    "is-selected": _vm.isSelectedHotel(_vm.showItem),
                    value: _vm.showItem
                  },
                  on: { select: _vm.onSelectHotel }
                })
              : _vm._e()
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-701818a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-701818a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/volo-hotel/modals/ModalHotelsMap.vue
// module id = null
// module chunks = 